import React from 'react';
import { Redirect, useParams } from 'react-router';
import { useFeatureToggle } from '@css-xp/base';
import { getRouteUrl } from '@css-xp/ppc-utils';

interface RedirectToggleProps {
  flag?: string;
  toEnable: string;
  toDisable: string;
}

export const RedirectToggle = ({ toEnable, toDisable, flag }: RedirectToggleProps) => {
  const [isEnabled] = useFeatureToggle();
  const { txaId } = useParams<{ txaId: string }>();
  const isFlagEnabled = isEnabled(flag);
  // the redirect is not able to append the txaId by default
  // so we are manually adding that functionality
  const toEnableUrl = getRouteUrl(toEnable, { txaId: txaId });
  const toDisableUrl = getRouteUrl(toDisable, { txaId: txaId });
  return <Redirect to={isFlagEnabled ? toEnableUrl : toDisableUrl} />;
};
